export const APP_NAME_TO_BYTEIO_APP_ID: Record<string, number> = {
  tiktokshop: 4068,
  ttspc: 359713,
  pearl: 5969,
  i18n_ecom_alliance: 4331,
  i18n_ecom_alliance_im: 382170,
  dbmp: 403986,
  ec_streamer_desktop: 253642,
  creator_platform_app_two: 1233,
  seller_center_app: 7743,
  partner_platform: 360019,
  data_infra_tts: 512768,
  'pearl-miniapp': 569738,
  seller_s_portal: 352699,
  band_compass: 474062,
  ecom_pigeon_i18n: 5341,
  pino_lowcode_platform: 619577,
  ux_insight_platform: 623948
};
